import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WorldTaxonomy } from '@surfline/quiver-react';
import MetaTags from '../../../components/MetaTags';
import { camsAndForecastsPaths, geonameMapPath } from '../../../utils/urls/camsAndForecastsPath';
import { fetchWorldTaxonomy } from '../../../actions/worldTaxonomy';
import worldTaxonomyPropType from '../../../propTypes/worldTaxonomy';

class CamsAndForecasts extends Component {
  static propTypes = {
    worldTaxonomy: PropTypes.arrayOf(worldTaxonomyPropType),
    doFetchWorldTaxonomy: PropTypes.func.isRequired,
  };

  static defaultProps = {
    worldTaxonomy: [],
  };

  static fetch = [fetchWorldTaxonomy];

  suffix = 'Surf Reports & Cams';

  componentDidMount() {
    document.documentElement.style.overflow = 'auto';
    const { worldTaxonomy, doFetchWorldTaxonomy } = this.props;
    if (!worldTaxonomy) {
      doFetchWorldTaxonomy();
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = null;
  }

  countryComponent = country => (
    <a href={geonameMapPath(country)}>
      {country.name} {this.suffix}
    </a>
  );

  render() {
    const { worldTaxonomy } = this.props;
    return (
      <div className="sl-cams-and-forecasts">
        <MetaTags
          title="Surfline Maps of Every Surf Spot in the World"
          description="Know Before You Go. Access to the world's best surf forecast team at Surfline and get the best travel and weather info along with live HD surf cams."
          urlPath={camsAndForecastsPaths.base}
        />
        <WorldTaxonomy
          taxonomy={worldTaxonomy}
          countryComponent={this.countryComponent}
          headerSuffix={this.suffix}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    worldTaxonomy: state.worldTaxonomy,
  }),
  dispatch => ({
    doFetchWorldTaxonomy: () => dispatch(fetchWorldTaxonomy),
  })
)(CamsAndForecasts);
